
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/talent-radar",
      function () {
        return require("private-next-pages/talent-radar/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/talent-radar"])
      });
    }
  